import { Component } from '@angular/core';
import {IconComponent} from '../icon/icon.component';
import {Icons} from '../../../model/icon';

@Component({
  selector: 'app-fc-loading',
  imports: [
    IconComponent
  ],
  templateUrl: './fc-loading.component.html',
  styleUrl: './fc-loading.component.scss'
})
export class FcLoadingComponent {

  protected readonly Icons = Icons;
}
